import React from "react";
import { Alert } from "react-bootstrap";

interface Props {
    message: string;
}

const MapEmptyState: React.FC<Props> = ({ message }) => (
    <Alert variant="light" className="map-empty-state">{message}</Alert>
);

export default MapEmptyState;
